export default __webpack_public_path__ + "static/media/chriss.f8fc8d47.jpg";